/**
 * Helper strings to provide easier association between tCMS IDs and template purpose/theme
 * These template IDS can be found by querying tCMS (and are provided when uploaded into the system).
 * Refer to TcmsService for more details.
 * NOTE: These are the original TM* template IDs - kept for backwards compatibility
 * Replace with new ones on flight graduation EnableNewTemplateIds
 */ export var TemplateIdConstants = /*#__PURE__*/ function(TemplateIdConstants) {
    /** Basic Plan/Planner Templates */ TemplateIdConstants["CreateBlankBasicPlanCardId"] = "createBlankPlan";
    TemplateIdConstants["SimpleBasicPlanTemplateId"] = "TM89235692";
    TemplateIdConstants["BusinessBasicPlanTemplateId"] = "TM22759591";
    TemplateIdConstants["EmployeeOnboardingBasicPlanTemplateId"] = "TM11863551";
    TemplateIdConstants["ProjectManagementBasicPlanTemplateId"] = "TM00726568";
    TemplateIdConstants["SoftwareDevelopmentBasicPlanTemplateId"] = "TM11133364";
    /** Premium Plan/Project Templates */ TemplateIdConstants["SimplePremiumPlanTemplateId"] = "TM33489844";
    TemplateIdConstants["ProjectManagementPremiumPlanTemplateId"] = "TM88889595";
    TemplateIdConstants["CommercialConstructionPremiumPlanTemplateId"] = "TM45446330";
    TemplateIdConstants["MarketingCampaignPremiumPlanTemplateId"] = "TM33634609";
    TemplateIdConstants["SoftwareDevelopmentPremiumPlanTemplateId"] = "TM11668731";
    TemplateIdConstants["BusinessPremiumPlanTemplateId"] = "TM66954678";
    TemplateIdConstants["EmployeeOnboardingPremiumPlanTemplateId"] = "TM33963130";
    TemplateIdConstants["SprintPlanningPremiumPlanTemplateId"] = "TM89690571";
    TemplateIdConstants["GoalsAndObjectivesPremiumPlanTemplateId"] = "TM56084195";
    TemplateIdConstants["SprintRetrospectivePremiumPlanTemplateId"] = "TM00639721";
    TemplateIdConstants["EventPlanningPremiumPlanTemplateId"] = "TM33693565";
    TemplateIdConstants["ProjectRetrospectivePremiumPlanTemplateId"] = "TM77945985";
    TemplateIdConstants["TrainingPlanPremiumPlanTemplateId"] = "TM33681953";
    TemplateIdConstants["ProjectBudgetPremiumPlanTemplateId"] = "TM55734375";
    TemplateIdConstants["CrmPipelinePremiumPlanTemplateId"] = "TM00405373";
    TemplateIdConstants["HelpDeskTicketsPremiumPlanTemplateId"] = "TM12197912";
    /** Copilot templates */ TemplateIdConstants["ResearchWithCopilotTemplateId"] = "TM11953924";
    TemplateIdConstants["CompetitiveAnalysisWithCopilotTemplateId"] = "TM77819305";
    TemplateIdConstants["SWOTAnalysisWithCopilotTemplateId"] = "TM34086013";
    TemplateIdConstants["MarketStudyWithCopilotTemplateId"] = "TM89612528";
    TemplateIdConstants["ContentCreationWithCopilotTemplateId"] = "TM45427482";
    TemplateIdConstants["CampaignLaunchWithCopilotTemplateId"] = "TM33728249";
    TemplateIdConstants["LearningPlanWithCopilotTemplateId"] = "TM33373652";
    TemplateIdConstants["WorkbackPlanWithCopilotTemplateId"] = "TM66937081";
    return TemplateIdConstants;
}({});
/**
 * New GUID-based template IDs
 * Remove with flight graduation EnableNewTemplateIds
 * @deprecated Use TemplateIdMapping or TemplateCompatibilityUtilities to convert between new and legacy IDs
 */ export var NewTemplateIdConstants = /*#__PURE__*/ function(NewTemplateIdConstants) {
    /** Basic Plan/Planner Templates */ NewTemplateIdConstants["SimpleBasicPlanTemplateId"] = "229ad1a0-26e7-407d-aff2-744c19050b1f";
    NewTemplateIdConstants["BusinessBasicPlanTemplateId"] = "3dec26f2-4c4c-49ef-857e-c4708492bb3d";
    NewTemplateIdConstants["EmployeeOnboardingBasicPlanTemplateId"] = "414afdac-153d-4d4f-a741-440ecbae4688";
    NewTemplateIdConstants["ProjectManagementBasicPlanTemplateId"] = "78b054a0-8832-4b7c-b0d7-d19f5b84e9c0";
    NewTemplateIdConstants["SoftwareDevelopmentBasicPlanTemplateId"] = "73f5a935-f68d-4af4-bbea-b3a8e91330d3";
    /** Premium Plan/Project Templates */ NewTemplateIdConstants["SimplePremiumPlanTemplateId"] = "b6558eaa-233c-4190-83ac-2045799c0879";
    NewTemplateIdConstants["ProjectManagementPremiumPlanTemplateId"] = "607348eb-0686-488f-9ba8-c5ef5f3b11c8";
    NewTemplateIdConstants["CommercialConstructionPremiumPlanTemplateId"] = "dce7c80b-c375-45fe-ba4f-859fa17b53fb";
    NewTemplateIdConstants["MarketingCampaignPremiumPlanTemplateId"] = "f92c726d-013d-4618-9869-31ee9928ac36";
    NewTemplateIdConstants["SoftwareDevelopmentPremiumPlanTemplateId"] = "a5ffb2b6-d85a-4559-b3e0-9d844facf216";
    NewTemplateIdConstants["BusinessPremiumPlanTemplateId"] = "ff83780d-693b-4b8c-af7d-50d52275fa0b";
    NewTemplateIdConstants["EmployeeOnboardingPremiumPlanTemplateId"] = "6933168a-a739-4a7c-a138-7b7b2a1189b8";
    NewTemplateIdConstants["SprintPlanningPremiumPlanTemplateId"] = "120bab47-5df4-4f63-8fd5-cb9d4fb910fe";
    NewTemplateIdConstants["GoalsAndObjectivesPremiumPlanTemplateId"] = "299c6ec4-f767-43cf-aaf7-b0ea112ff0b9";
    NewTemplateIdConstants["SprintRetrospectivePremiumPlanTemplateId"] = "a3e90e39-dffb-4de3-9f6f-5bbb37d455ee";
    NewTemplateIdConstants["EventPlanningPremiumPlanTemplateId"] = "b9837ecb-fe20-4440-a738-2e528cb861ee";
    NewTemplateIdConstants["ProjectRetrospectivePremiumPlanTemplateId"] = "9372016e-b823-41e1-b58c-63f8da4543b9";
    NewTemplateIdConstants["TrainingPlanPremiumPlanTemplateId"] = "be612b37-ee1b-4324-a072-05652fe43b08";
    NewTemplateIdConstants["CrmPipelinePremiumPlanTemplateId"] = "29cf8168-7982-4f1f-9f77-c079dc8e433d";
    NewTemplateIdConstants["HelpDeskTicketsPremiumPlanTemplateId"] = "16cfaa35-8d47-4c89-b0ec-939b0edd286b";
    /** Copilot templates */ NewTemplateIdConstants["ResearchWithCopilotTemplateId"] = "821be2b1-514a-489b-98f6-6aef8fa9e61f";
    NewTemplateIdConstants["CompetitiveAnalysisWithCopilotTemplateId"] = "7d6ede32-e21a-470f-8452-930133fcfd6d";
    NewTemplateIdConstants["SWOTAnalysisWithCopilotTemplateId"] = "68af7855-6bac-4cc0-ba0c-ffcedf639261";
    NewTemplateIdConstants["MarketStudyWithCopilotTemplateId"] = "bd4a8e09-300d-44aa-bc37-0f1b7760d071";
    NewTemplateIdConstants["ContentCreationWithCopilotTemplateId"] = "a13479f8-a1df-40a2-9399-8746ab2125d6";
    NewTemplateIdConstants["CampaignLaunchWithCopilotTemplateId"] = "499c4ac0-aa59-470b-a41d-69972873973c";
    NewTemplateIdConstants["LearningPlanWithCopilotTemplateId"] = "b0153820-c420-45e5-858f-3376de547e00";
    return NewTemplateIdConstants;
}({});
/**
 * Mapping between new GUID template IDs and legacy TM* template IDs
 * Remove with flight graduation EnableNewTemplateIds
 */ export const TemplateIdMapping = {
    ["229ad1a0-26e7-407d-aff2-744c19050b1f"]: "TM89235692",
    ["3dec26f2-4c4c-49ef-857e-c4708492bb3d"]: "TM22759591",
    ["414afdac-153d-4d4f-a741-440ecbae4688"]: "TM11863551",
    ["78b054a0-8832-4b7c-b0d7-d19f5b84e9c0"]: "TM00726568",
    ["73f5a935-f68d-4af4-bbea-b3a8e91330d3"]: "TM11133364",
    ["b6558eaa-233c-4190-83ac-2045799c0879"]: "TM33489844",
    ["607348eb-0686-488f-9ba8-c5ef5f3b11c8"]: "TM88889595",
    ["dce7c80b-c375-45fe-ba4f-859fa17b53fb"]: "TM45446330",
    ["f92c726d-013d-4618-9869-31ee9928ac36"]: "TM33634609",
    ["a5ffb2b6-d85a-4559-b3e0-9d844facf216"]: "TM11668731",
    ["ff83780d-693b-4b8c-af7d-50d52275fa0b"]: "TM66954678",
    ["6933168a-a739-4a7c-a138-7b7b2a1189b8"]: "TM33963130",
    ["120bab47-5df4-4f63-8fd5-cb9d4fb910fe"]: "TM89690571",
    ["299c6ec4-f767-43cf-aaf7-b0ea112ff0b9"]: "TM56084195",
    ["a3e90e39-dffb-4de3-9f6f-5bbb37d455ee"]: "TM00639721",
    ["b9837ecb-fe20-4440-a738-2e528cb861ee"]: "TM33693565",
    ["9372016e-b823-41e1-b58c-63f8da4543b9"]: "TM77945985",
    ["be612b37-ee1b-4324-a072-05652fe43b08"]: "TM33681953",
    ["29cf8168-7982-4f1f-9f77-c079dc8e433d"]: "TM00405373",
    ["16cfaa35-8d47-4c89-b0ec-939b0edd286b"]: "TM12197912",
    ["821be2b1-514a-489b-98f6-6aef8fa9e61f"]: "TM11953924",
    ["7d6ede32-e21a-470f-8452-930133fcfd6d"]: "TM77819305",
    ["68af7855-6bac-4cc0-ba0c-ffcedf639261"]: "TM34086013",
    ["bd4a8e09-300d-44aa-bc37-0f1b7760d071"]: "TM89612528",
    ["a13479f8-a1df-40a2-9399-8746ab2125d6"]: "TM45427482",
    ["499c4ac0-aa59-470b-a41d-69972873973c"]: "TM33728249",
    ["b0153820-c420-45e5-858f-3376de547e00"]: "TM33373652"
};
/**
 * Template categories that can be rendered in the app.
 * Each category may correspond to one or more templateIds from tcms, depending on the basic / premium support for the template.
 */ export var TemplateCategory = /*#__PURE__*/ function(TemplateCategory) {
    TemplateCategory["Blank"] = "blank";
    TemplateCategory["Simple"] = "simple";
    TemplateCategory["Business"] = "business";
    TemplateCategory["EmployeeOnboarding"] = "employeeonboarding";
    TemplateCategory["ProjectManagement"] = "projectmanagement";
    TemplateCategory["SoftwareDevelopment"] = "softwaredevelopment";
    TemplateCategory["CommercialConstruction"] = "commercialconstruction";
    TemplateCategory["MarketingCampaign"] = "marketingcampaign";
    TemplateCategory["SprintPlanning"] = "sprintplanning";
    TemplateCategory["GoalsAndObjectives"] = "goalsandobjectives";
    TemplateCategory["SprintRetrospective"] = "sprintretrospective";
    TemplateCategory["EventPlanning"] = "eventplanning";
    TemplateCategory["ProjectRetrospective"] = "projectretrospective";
    TemplateCategory["TrainingPlan"] = "trainingplan";
    TemplateCategory["ProjectBudget"] = "projectbudget";
    TemplateCategory["CrmPipeline"] = "crmpipeline";
    TemplateCategory["HelpDeskTickets"] = "helpdesktickets";
    return TemplateCategory;
}({});
/**
 * List of all the copilot/ ProjectManager templates
 * Planner Copilot has been re-branded to ProjectManager so the code can refer to the same thing using 2 different terms
 */ export const CopilotTemplateIds = [
    "TM11953924",
    "TM77819305",
    "TM34086013",
    "TM89612528",
    "TM45427482",
    "TM33728249",
    "TM33373652",
    "TM66937081",
    "821be2b1-514a-489b-98f6-6aef8fa9e61f",
    "7d6ede32-e21a-470f-8452-930133fcfd6d",
    "68af7855-6bac-4cc0-ba0c-ffcedf639261",
    "bd4a8e09-300d-44aa-bc37-0f1b7760d071",
    "a13479f8-a1df-40a2-9399-8746ab2125d6",
    "499c4ac0-aa59-470b-a41d-69972873973c",
    "b0153820-c420-45e5-858f-3376de547e00"
];
/**
 * The different lists that are available for indexing in the template service
 * See ITemplateMetadataResource.ts and ITcmsApi.ts
 */ export var TemplateListType = /*#__PURE__*/ function(TemplateListType) {
    /**
     * Used for querying plan built-in templates.
     * TODO: This is the placeholder template list for Evo plans, can be updated when we work with tCMS
     * to support Evo plans.
     */ TemplateListType["PlanProduction"] = "evoplannertemplates";
    /**
     * Used for querying basic plan/planner built-in templates
     */ TemplateListType["BasicPlanProduction"] = "officetemplatesplanner";
    /**
     * Used for querying premium plan/project built-in templates
     */ TemplateListType["PremiumPlanProduction"] = "officetemplatesprojectfortheweb";
    /**
     * Used for querying test premium plan/project built-in templates
     */ TemplateListType["PremiumPlanTest"] = "officetemplatesprojectforthewebppe";
    /**
     * Used for integration testing with tCMS
     */ TemplateListType["IntegrationTest"] = "officetemplatesdesktoprojectstart";
    /**
     * Used for local unit testing, not hosted on tCMS
     */ TemplateListType["UnitTest"] = "fakeList";
    return TemplateListType;
}({});
/**
 * Different regex patterns used to identify and manipulate text highlighting in ProjectManager page prompt
 * Text in a string (goal) is identified by the pattern `{{%prompt_text%}}`
 */ export const ProjectManagerPromptHighlightTextRegex = {
    /** Regex to strip a goal string off the identifiers */ IDENTIFIER_REGEX: /\{\{%(.+?)%\}\}/g,
    /** Regex to identify individual substrings */ HIGHLIGHT_REGEX: /\{\{%.*?%\}\}/g,
    /** Regex to check/remove for identifiers  */ CHECK_REGEX: /\{\{%\s*[^%]+?\s*%\}\}/,
    /** Regex to replace all identifiers */ REPLACE_IDENTIFIERS_REGEX: /\{\{%\s*[^%]+?\s*%\}\}/g
};
export var SearchPlanTemplateType = /*#__PURE__*/ function(SearchPlanTemplateType) {
    /** Search for templates that are created by Microsoft (e.g. global templates) */ SearchPlanTemplateType["ByMicrosoft"] = "byMicrosoft";
    /** Search for templates that the user can access */ SearchPlanTemplateType["SharedWithMe"] = "sharedWithMe";
    /** Search for templates that are created by the user */ SearchPlanTemplateType["CreatedByMe"] = "createdByMe";
    return SearchPlanTemplateType;
}({});
/** SP folder that stores all custom templates */ export const PlannerTemplateFolder = "Planner - Custom templates";
/** Custom plan template extension */ export const PlanTemplateFileExtension = "plat";
/** Characters not allowed in OneDrive file/folder names */ export const INVALID_FILENAME_CHARS_REGEX = /["*:<>?/\\|]/;
/** Reserved file names that can't be used (case-insensitive exact match) */ export const RESERVED_FILENAME_REGEX = /^(CON|PRN|AUX|NUL|COM[0-9]|LPT[0-9]|\.lock|desktop\.ini)$/i;
/** File names starting with ~$ are not allowed */ export const STARTS_WITH_TILDE_DOLLAR_REGEX = /^~\$/;
/** _vti_ can't appear anywhere in a file name */ export const CONTAINS_VTI_REGEX = /_vti_/i;
/** Default size of the search result */ export const DefaultTemplateSearchSize = 50;
/**
 * Defines the status of a create template from plan operation.
 */ export var CreateTemplateOperationStatus = /*#__PURE__*/ function(CreateTemplateOperationStatus) {
    CreateTemplateOperationStatus[CreateTemplateOperationStatus["NotStarted"] = 0] = "NotStarted";
    CreateTemplateOperationStatus[CreateTemplateOperationStatus["InProgress"] = 1] = "InProgress";
    CreateTemplateOperationStatus[CreateTemplateOperationStatus["Succeeded"] = 2] = "Succeeded";
    CreateTemplateOperationStatus[CreateTemplateOperationStatus["Failed"] = 3] = "Failed";
    return CreateTemplateOperationStatus;
}({});
